import { ButtonItems } from "../../types/Component";
import { CardSubtitle } from "../../types/CoreComponents";

export const DefaultButtonsData: ButtonItems[] = [
  {
    color: "primary",
    title: "Primary Button",
    id: "default1",
  },
  {
    color: "secondary",
    id: "default2",
    title: "Secondary Button",
  },
  {
    color: "success",
    id: "default3",
    title: "Success Button",
  },
  {
    color: "info",
    id: "default4",
    title: "Info Button",
  },
  {
    id: "default5",
    color: "warning",
    title: "Warning Button",
  },
  {
    id: "default6",
    color: "danger",
    title: "Danger Button",
  },
  {
    color: "light",
    id: "default7",
    title: "Light Button",
  },
];

export const SizingButtonsData: ButtonItems[] = [
  {
    id: "largeButton1",
    color: "primary",
    size: "lg",
    title: "Primary Button",
  },
  {
    id: "largeButton2",
    color: "secondary",
    size: "lg",
    title: "Secondary Button",
  },
  {
    id: "largeButton3",
    color: "success",
    title: "Success Button",
    size: "lg",
  },
  {
    id: "largeButton4",
    color: "info",
    title: "Info Button",
    size: "lg",
  },
  {
    id: "largeButton5",
    color: "warning",
    size: "lg",
    title: "Warning Button",
  },
  {
    id: "largeButton6",
    size: "lg",
    color: "danger",
    title: "Danger Button",
  },
  {
    id: "largeButton7",
    color: "light",
    size: "lgW",
    title: "Light Button",
  },
];

export const DisableButtonsData: ButtonItems[] = [
  {
    disabled: true,
    color: "primary",
    title: "Disabled",
    id: "disabled1",
  },
  {
    disabled: true,
    color: "secondary",
    id: "disabled2",
    title: "Disabled",
  },
  {
    disabled: true,
    color: "success",
    id: "disabled3",
    title: "Disabled",
  },
  {
    disabled: true,
    color: "info",
    id: "disabled4",
    title: "Disabled",
  },
  {
    disabled: true,
    id: "disabled5",
    color: "warning",
    title: "Disabled",
  },
  {
    disabled: true,
    id: "disabled6",
    color: "danger",
    title: "Disabled",
  },
  {
    disabled: true,
    color: "light",
    id: "disabled7",
    title: "Disabled",
  },
];

export const ActiveButtonsData: ButtonItems[] = [
  {
    active: true,
    color: "primary",
    title: "Active",
    id: "active1",
  },
  {
    active: true,
    color: "secondary",
    id: "active2",
    title: "Active",
  },
  {
    active: true,
    color: "success",
    id: "active3",
    title: "Active",
  },
  {
    active: true,
    color: "info",
    id: "active4",
    title: "Active",
  },
  {
    active: true,
    id: "active5",
    color: "warning",
    title: "Active",
  },
  {
    active: true,
    id: "active6",
    color: "danger",
    title: "Active",
  },
  {
    active: true,
    color: "light",
    id: "active7",
    title: "Active",
  },
];

export const OutlineButtonsData: ButtonItems[] = [
  {
    outline: true,
    color: "primary",
    title: "Primary Button",
    id: "outLine1",
  },
  {
    outline: true,
    color: "secondary",
    id: "outLine2",
    title: "Secondary Button",
  },
  {
    outline: true,
    color: "success",
    id: "outLine3",
    title: "Success Button",
  },
  {
    outline: true,
    color: "info",
    id: "outLine4",
    title: "Info Button",
  },
  {
    outline: true,
    id: "outLine5",
    color: "warning",
    title: "Warning Button",
  },
  {
    outline: true,
    id: "outLine6",
    color: "danger",
    title: "Danger Button",
  },
  {
    outline: true,
    color: "light",
    id: "outLine7",
    title: "Light Button",
  },
];

export const BoldBorderOutlineButtonsData: ButtonItems[] = [
  {
    outline: true,
    color: "primary-2x",
    title: "Primary Button",
    id: "boldBorderOutLine1",
  },
  {
    outline: true,
    color: "secondary-2x",
    id: "boldBorderOutLine2",
    title: "Secondary Button",
  },
  {
    outline: true,
    color: "success-2x",
    id: "boldBorderOutLine3",
    title: "Success Button",
  },
  {
    outline: true,
    color: "info-2x",
    id: "boldBorderOutLine4",
    title: "Info Button",
  },
  {
    outline: true,
    id: "boldBorderOutLine5",
    color: "warning-2x",
    title: "Warning Button",
  },
  {
    outline: true,
    id: "boldBorderOutLine6",
    color: "danger-2x",
    title: "Danger Button",
  },
  {
    outline: true,
    color: "light-2x txt-dark",
    id: "boldBorderOutLine7",
    title: "Light Button",
  },
];

export const GradientButtonsData: ButtonItems[] = [
  {
    color: "primary-gradien",
    title: "Primary Button",
    id: "gradientButtons1",
  },
  {
    color: "secondary-gradien",
    id: "gradientButtons2",
    title: "Secondary Button",
  },
  {
    color: "success-gradien",
    id: "gradientButtons3",
    title: "Success Button",
  },
  {
    color: "info-gradien",
    id: "gradientButtons4",
    title: "Info Button",
  },
  {
    id: "gradientButtons5",
    color: "warning-gradien",
    title: "Warning Button",
  },
  {
    id: "gradientButtons6",
    color: "danger-gradien",
    title: "Danger Button",
  },
];

export const DefaultButtonText: CardSubtitle[] = [
  {
    text: "Bootstrap state buttons",
  },
];

export const FlatButtonSubTitle: CardSubtitle[] = [
  {
    text: "Add ",
    code: ".btn-square",
  },
  {
    text: " class for flat button",
  },
];

export const RaisedButtonSubTitle: CardSubtitle[] = [
  {
    text: "Add ",
    code: ".btn-pill",
  },
  {
    text: " and ",
    code: ".btn-air-*",
  },
  {
    text: " class button",
  },
];

export const SizingButtonSubTitle: CardSubtitle[] = [
  {
    text: "Add ",
    code: "btn-lg",
  },
  {
    code: " .btn-sm",
  },
  {
    code: " .btn-xs",
  },
  {
    text: " class for Different Sizing buttons",
  },
];

export const ActiveButtonSubTitle: CardSubtitle[] = [
  {
    text: "Add ",
    code: ".active",
  },
  {
    text: " class for active state",
  },
];

export const OutlineButtonSubTitle: CardSubtitle[] = [
  {
    text: "Add ",
    code: ".btn-outline-*",
  },
  {
    text: " class for border button",
  },
];

export const BoldBorderOutlineButtonSubTitle: CardSubtitle[] = [
  {
    text: "Add ",
    code: ".btn-outline-*-2x",
  },
  {
    text: " class for bold outline",
  },
];

export const GradientButtonsSubTitle: CardSubtitle[] = [
  {
    text: "Add ",
    code: ".btn-*-gradient",
  },
  {
    text: " class for gradient button",
  },
];

export const DisabledButtonSubTitle: CardSubtitle[] = [
  {
    text: "Add ",
    code: ".disabled",
  },
  {
    text: " class or ",
    code: 'disabled="disabled"',
  },
  {
    text: " attribute for disabled button",
  },
];
